// extracted by mini-css-extract-plugin
export default {"panel":"ChatSuggestedPrompts_panel__ubZDX","chip":"ChatSuggestedPrompts_chip__-zpb0","footer":"ChatSuggestedPrompts_footer__veDwd"};